import { Component } from '@angular/core';

import { Platform } from '@ionic/angular';
import { SplashScreen } from '@ionic-native/splash-screen/ngx';
import { StatusBar } from '@ionic-native/status-bar/ngx';
import { ScreenOrientation } from '@ionic-native/screen-orientation/ngx';
import { environment } from 'src/environments/environment';
import { ServiciosService } from './services/servicios.service';
import { AuthService } from './services/auth.service';

@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html'
})
export class AppComponent {

  constructor(
    private platform: Platform,
    private splashScreen: SplashScreen,
    private statusBar: StatusBar,
    private screen: ScreenOrientation,
    private serviciosService: ServiciosService,
    private auth: AuthService,
  ) {
    this.auth.loginFalso();
    this.initializeApp();

    document.title = environment.personalizado.tituloWeb || 'G2kMarcajes';

    // Manifest
    const stringManifest = JSON.stringify(environment.personalizado.manifest);
    const blob = new Blob([stringManifest], {type: 'application/json'});
    const manifestURL = URL.createObjectURL(blob);
    document.querySelector('#manifest-placeholder').setAttribute('href', manifestURL);

    // Favicon
    document.querySelector('#favicon-placeholder').setAttribute('href', environment.personalizado.enlaceFavicon);

    // Color del tema
    document.querySelector('#color-tema-placeholder').setAttribute('content', environment.personalizado.colorTema);
  }
  initializeApp() {
    this.platform.ready().then(async () => {

      this.statusBar.styleDefault();
      this.splashScreen.hide();
      if (this.platform.is('cordova')) {
        this.screen.lock('portrait');
      }
    });

  }
}
